export function focusAddressSelectInputAfterOpen({ inputSelectRef }) {
  inputSelectRef.current?.focus()
}

export function showAddressSelectDropdownListFooter({ Footer }) {
  return !!Footer
}
